import styled, { css } from 'styled-components';

export const ItemContainer = styled.div<{ deleted?: boolean }>`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-right: 16px;
  overflow: hidden;
  transition: max-height 0.2s;
  max-height: 300px;
  .notification-item-link {
    display: block;
    flex: 1;
  }
  ${({ deleted }) =>
    deleted &&
    css`
      max-height: 0;
    `}
`;

export const Item = styled.div<{ active?: boolean }>`
  width: 100%;
  cursor: pointer;
  padding: 20px 16px;
  background-color: transparent;
  border: none;
  position: relative;
  text-align: left;
  display: flex;
  align-items: flex-start;
  ${({ active }) =>
    active &&
    css`
      &::before {
        content: '';
        position: absolute;
        width: 8px;
        height: 8px;
        top: 10px;
        left: 10px;
        background-color: #4385f5;
        border-radius: 4px;
      }
    `}
`;

export const IconContainer = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: ${({ active }) => (active ? '#4385F5' : '#9CA3BF')};
  margin-right: 12px;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const MenuContainer = styled.button`
  display: inline-block;
  transform: rotate(90deg);
  cursor: pointer;
  background-color: transparent;
  border: none;
  margin-top: 20px;
`;

export const ActionButton = styled.span`
  cursor: pointer;
`;
